import { render, staticRenderFns } from "./comOrderMethod.vue?vue&type=template&id=8dfb3536&scoped=true"
import script from "./comOrderMethod.vue?vue&type=script&lang=js"
export * from "./comOrderMethod.vue?vue&type=script&lang=js"
import style0 from "./comOrderMethod.vue?vue&type=style&index=0&id=8dfb3536&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfb3536",
  null
  
)

export default component.exports